<template>
	<div id="wrapper">
		<SidebarView :cashier="true" :cashierVisible="true" :cdcApprovals="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<div class="card card-shape home-box mb-3">
						<div class="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
							<h6 class="m-0 fw-bold text-green">CDC Approvals</h6>
						</div>
						<div class="card-body">
							<div class="alert alert-info small mb-0">
								This page is reserved for supervisors with <strong>cdc_approve_reject</strong> permission.
							</div>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>
	</div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";

export default {
	name: "CdcApprovals",
	components: {
		SidebarView,
		TopbarView,
	},
};
</script>

